import { isExists, differenceInDays, isBefore, isSaturday, isSunday, isSameDay } from "date-fns";
import { parseISO } from "date-fns/esm";

const FERIADOS_NACIONAIS_2021_2022 = [
  {
    date: '2021-01-01',
    name: 'Confraternização mundial',
    type: 'national',
  },
  {
    date: '2021-02-16',
    name: 'Carnaval',
    type: 'national',
  },
  {
    date: '2021-04-04',
    name: 'Páscoa',
    type: 'national',
  },
  {
    date: '2021-04-21',
    name: 'Tiradentes',
    type: 'national',
  },
  {
    date: '2021-05-01',
    name: 'Dia do trabalho',
    type: 'national',
  },
  {
    date: '2021-06-03',
    name: 'Corpus Christi',
    type: 'national',
  },
  {
    date: '2021-09-07',
    name: 'Independência do Brasil',
    type: 'national',
  },
  {
    date: '2021-10-12',
    name: 'Nossa Senhora Aparecida',
    type: 'national',
  },
  {
    date: '2021-11-02',
    name: 'Finados',
    type: 'national',
  },
  {
    date: '2021-11-15',
    name: 'Proclamação da República',
    type: 'national',
  },
  {
    date: '2021-12-25',
    name: 'Natal',
    type: 'national',
  },
  {
    date: '2022-01-01',
    name: 'Confraternização mundial',
    type: 'national',
  },
  {
    date: '2022-03-01',
    name: 'Carnaval',
    type: 'national',
  },
  {
    date: '2022-04-17',
    name: 'Páscoa',
    type: 'national',
  },
  {
    date: '2022-04-21',
    name: 'Tiradentes',
    type: 'national',
  },
  {
    date: '2022-05-01',
    name: 'Dia do trabalho',
    type: 'national',
  },
  {
    date: '2022-06-16',
    name: 'Corpus Christi',
    type: 'national',
  },
  {
    date: '2022-09-07',
    name: 'Independência do Brasil',
    type: 'national',
  },
  {
    date: '2022-10-12',
    name: 'Nossa Senhora Aparecida',
    type: 'national',
  },
  {
    date: '2022-11-02',
    name: 'Finados',
    type: 'national',
  },
  {
    date: '2022-11-15',
    name: 'Proclamação da República',
    type: 'national',
  },
  {
    date: '2022-12-25',
    name: 'Natal',
    type: 'national',
  },
];

export default (value, questionModel) => {
  const fullData = value.replace("- ", "");
  const [date, time] = fullData.split(" ");

  if (date && time) {
    let [dayString, monthString] = date.split("/");
    let [hourString, minutesString] = time.split(":");

    const year = new Date().getFullYear();
    const month = Number(monthString);
    const day = Number(dayString);
    const hour = Number(hourString);
    const minutes = Number(minutesString);

    // validate day and month
    if (!isExists(year, month - 1, day)) {
      questionModel.description = `❌ Algo está incorreto na data: ${day}/${
        month > 9 ? month : `0${month}`
      }`;
      return false;
    }

    // validate hour
    if ((hour === 18 && minutes > 0) || hour > 18 || hour < 8) {
      questionModel.description =
        "❌ Coletas são permitidas apenas das 8:00 às 18:00";
      return false;
    }

    // validate minutes
    if (minutes >= 60 || minutes < 0) {
      questionModel.description = "❌ Os minutos estão inválidos";
      return false;
    }

    // day/month exist AND hour/minutes is correct
    const dateObject = new Date(year, month - 1, day, hour, minutes);

    const dateObjectDateIsHoliday = FERIADOS_NACIONAIS_2021_2022.filter(holiday => isSameDay(parseISO(holiday.date), dateObject))[0]
    if (dateObjectDateIsHoliday) {
      questionModel.description =
        `❌ Não realizamos coletas no feriado da(o) ${dateObjectDateIsHoliday.name}`;
      return false
    }

    if (differenceInDays(dateObject, new Date()) > 15) {
      questionModel.description =
        "❌ A coleta pode ser feita no máximo 15 dias a frente de hoje.";
      return false;
    }

    if (isBefore(dateObject, new Date())) {
      questionModel.description =
        "❌ A data/horário limite da coleta não pode ser um dia/hora que já passou.";
      return false;
    }

    if (isSunday(dateObject) || isSaturday(dateObject)) {
      questionModel.description =
        "❌ Não realizamos coletas nos finais de semana.";
      return false;
    }

    questionModel.description = "";
    return true;
  }

  return false;
};
